import { createReducer, on } from '@ngrx/store';
import * as CoinTransactionActions from './coin-transaction.actions';
import { CoinTransaction } from '../../models/CoinTransaction';

export interface CoinTransactionState {
  coinTransactions: CoinTransaction[] | null;
}

export const initialState: CoinTransactionState = {
  coinTransactions: null
};

export const coinTransactionReducer = createReducer(
  initialState,
  on(CoinTransactionActions.getCoinTransactionsSuccess, (state, { coinTransactions }) => ({
    ...state,
    coinTransactions
  })),
  on(CoinTransactionActions.getCoinTransactionsByCustomerNoSuccess, (state, { coinTransactions }) => ({
    ...state,
    coinTransactions
  })),
  on(CoinTransactionActions.getMyCoinTransactionsSuccess, (state, { coinTransactions }) => ({
    ...state,
    coinTransactions
  })),
  on(CoinTransactionActions.addCoinTransactionSuccess, (state, { coinTransaction }) => ({
    ...state,
    coinTransactions: state.coinTransactions ? [coinTransaction, ...state.coinTransactions] : [coinTransaction]
  }))
);
